import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import PeoplesoftWriterForm from '../forms/peoplesoft-writer-form';
import { peoplesoftWriterValidationSchema } from '../schema/peoplesoftWriter.js';

export default function PeoplesoftWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'PeopleSoft Writer Node Details',
        altText: 'PeopleSoft Writer Node',
        defaultLabel: 'PeopleSoft Writer Node',
      }}
    >
      <CommonNode
        FormComponent={PeoplesoftWriterForm}
        schemaResolver={peoplesoftWriterValidationSchema}
      />
    </NodeProvider>
  );
}
